import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { IrisCardModule } from '@sondermind/iris/card';
import { ReferralAuthorization } from '@sondermind/utilities/models-patient';

import { toVaAuthorizationRow, VaAuthorizationRowVm } from './va-authorization-row.vm';

/**
 * Read-only "VA Authorizations" card on the provider portal Payment tab. Lists a
 * VA client's referral authorizations newest-first (the array arrives pre-sorted).
 * Self-hides when there are no authorizations, so the host can embed it
 * unconditionally.
 */
@Component({
  selector: 'member-va-authorizations-card',
  templateUrl: './va-authorizations-card.component.html',
  styleUrls: ['./va-authorizations-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IrisCardModule]
})
export class VaAuthorizationsCardComponent {
  readonly authorizations = input<ReferralAuthorization[] | null | undefined>([]);

  protected readonly rows = computed<VaAuthorizationRowVm[]>(
    () => (this.authorizations() ?? []).map(toVaAuthorizationRow)
  );
}
